import __base_store from '@/store/__base_store'

/**
 * Store de rendimiento de inventario (modelo `inventory_performance`) construido desde el factory común.
 */
export default __base_store({
	state: {
		model_name: 'inventory_performance',
	},
})

